export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    // Validate file first
    if (!file) {
      reject(new Error('No file provided'));
      return;
    }

    if (!file.type.startsWith('image/')) {
      reject(new Error('File is not an image'));
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result as string;

      // Validate the result
      if (!result || !result.startsWith('data:')) {
        reject(new Error('Invalid base64 result'));
        return;
      }

      console.log('Base64 conversion successful, length:', result.length);
      resolve(result);
    };

    reader.onerror = (error) => {
      console.error('FileReader error:', error);
      reject(error);
    };

    reader.readAsDataURL(file);
  });
};
